import { useInfiniteQuery } from '@tanstack/react-query';
import { useCallback, useEffect, useMemo, useRef } from 'react';

import { heySynclyService } from '../api';

export const useHeySynclyHistory = () => {
  const offset = useRef(0);
  const pageSize = 20;

  const infiniteQuery = useInfiniteQuery({
    queryKey: ['hey-syncly-history'],
    queryFn: ({ pageParam }) =>
      heySynclyService.RetrieveHeySynclyChats(pageParam?.offset || 0, pageSize),
    initialPageParam: undefined as { offset: number } | undefined,
    getNextPageParam: (lastPage) =>
      lastPage.length === pageSize
        ? { offset: offset.current + pageSize }
        : undefined,
  });

  // v5 마이그레이션: onSuccess 콜백을 useEffect로 대체
  useEffect(() => {
    if (infiniteQuery.data) {
      const pages = infiniteQuery.data.pages;
      offset.current = pages[pages.length - 1].length;
    }
  }, [infiniteQuery.data]);

  const deleteHeySynclyChat = useCallback(
    async (chat_alias: Alias) => {
      await heySynclyService.DeleteHeySynclyChat(chat_alias);
      infiniteQuery.refetch();
    },
    [infiniteQuery.refetch],
  );

  const flattenData = useMemo(() => {
    return infiniteQuery.data?.pages.flatMap((page) => page) || [];
  }, [infiniteQuery.data]);

  return {
    ...infiniteQuery,
    data: flattenData,
    deleteHeySynclyChat,
  };
};
